import { EditPasswordPost } from '@_types/shared/Profile';
import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const editPasswordRequest = createAction('editPasswordRequest');
export const editPasswordSuccess = createAction('editPasswordSuccess');
export const editPasswordFailure = createAction('editPasswordFailure');

export const editPassword =
    (postbody: EditPasswordPost) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(editPasswordRequest());

        try {
            await api.post(`admin/profile/password`, postbody);

            dispatch(editPasswordSuccess());
        } catch (e) {
            handleApiErrors(dispatch, editPasswordFailure, e);
        }
    };
